import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Typography } from '@robinpowered/ui-kit';
import { SpaceItem } from './SpaceItem';
import { ActivityCard } from './ActivityCard';
import { useTranslation } from 'react-i18next';

export const AddSpaceCard: FC = () => {
  const { t } = useTranslation('downloadMobileAppModal');
  return (
    <Card>
      <ContentWrapper>
        <Typography.Paragraph
          style={{ marginBottom: '20px', fontWeight: '500', textAlign: 'left' }}
        >
          {t('add_space_card_title')}
        </Typography.Paragraph>
        <SpaceItem name={t('space_item_name_1')} />
        <SpaceItem name={t('space_item_name_2')} />
      </ContentWrapper>
      <ActivityCard />
    </Card>
  );
};

const Card = styled.div`
  border: 1px solid #cbc9c9;
  border-radius: 8px;
  padding: 11px;
  max-width: fit-content;
  height: 190px;
  margin-left: -26px;
  background-color: white;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
`;

const ContentWrapper = styled.div`
  margin-bottom: -112px;
`;
